import React from "react";

export class AboutOverlay extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {

        // show/hide
        var classes = "overlay";

        if(!this.props.open) {
            classes += " hidden";
        }


        return (
            <div className={classes}>
                <div className="overlay-inner">
                    <div className="header">About</div>

                    <div className="body">
                        &copy; Made by Net &lt;3
                        <br /><br />
                        [ <a href="http://twitter.com/metal_orb" target="_blank">twitter</a> ]{" "}
                        [ <a href="http://acroma.rf.gd" target="_blank">portfolio</a> ]
                    </div>

                    <div className="footer">
                        <button onClick={this.props.toggle}>Close</button>
                    </div>
                </div>
            </div>
        );
    }
}


AboutOverlay.defaultProps = {
    open: false
};
